const clampHours = (raw) => {
  const digits = raw.replace(/[^\d.]/g, "").slice(0, 5);
  return digits;
};

export const SaccoBusinessCase = ({ hours, onHoursChange }) => {
  const n = parseFloat(hours);
  const hasValue = !Number.isNaN(n) && n > 0;
  return (
    <section className="bg-[#F5F7F7]" data-testid="sacco-business-case">
      <div className="mx-auto max-w-6xl px-5 py-20 sm:py-24">
        <h2 className="text-2xl font-extrabold text-[#0B2A28] sm:text-3xl" data-testid="sacco-business-case-heading">The Business Case</h2>
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          <div className="rounded-3xl border border-neutral-200 bg-white p-8 sm:p-10" data-testid="sacco-case-manual">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-neutral-500">Manual Vetting Today</p>
            <label className="mt-4 flex items-baseline gap-2 text-5xl font-extrabold tracking-tight text-[#0B2A28] sm:text-6xl">
              <span className="relative inline-flex items-baseline">
                <input type="text" inputMode="decimal" value={hours} placeholder="X" aria-label="Your manual vetting hours per loan"
                  onChange={(e) => onHoursChange(clampHours(e.target.value))}
                  className="w-[2.6ch] min-w-[1.6ch] rounded-lg border-b-4 border-dashed border-[#E3B84C] bg-[#FDF7E9] px-1 text-center text-[#0B2A28] outline-none transition-[border-color,background-color] placeholder:text-[#D4A83A]/70 focus:border-solid focus:border-[#0A8B85] focus:bg-white"
                  style={{ width: `${Math.max(1.6, (hours || "X").length + 0.8)}ch` }}
                  data-testid="sacco-case-hours-input" />
              </span>
              <span>hrs</span>
            </label>
            <p className="mt-4 text-sm leading-relaxed text-neutral-600 sm:text-base">
              staff time spent per loan on guarantor and security verification alone.
            </p>
            <p className="mt-3 text-xs font-semibold text-[#8A6A1E]" data-testid="sacco-case-hours-hint">
              {hasValue
                ? `That is roughly ${n >= 10 ? Math.round(n) : n}× the time of a Clinq repayment-capacity check.`
                : "Type your SACCO's own figure to make the comparison yours."}
            </p>
          </div>
          <div className="rounded-3xl bg-[#0A8B85] p-8 text-white sm:p-10" data-testid="sacco-case-clinq">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-[#B9F0EC]">With Clinq</p>
            <p className="mt-4 text-5xl font-extrabold tracking-tight sm:text-6xl">
              <span className="text-[#E3B84C]">&lt;</span> 1 hr
            </p>
            <p className="mt-4 text-sm leading-relaxed text-white/90 sm:text-base">
              to run a repayment-capacity check across an entire application batch.
            </p>
          </div>
        </div>
        <p className="mt-10 max-w-4xl text-base font-bold leading-relaxed text-[#0B2A28] md:text-lg" data-testid="sacco-case-statement">
          The real cost is not just screening time — it is what happens after disbursement. Each avoidable default means a
          guarantor forced to repay, collateral enforced, or other members' balances absorbing the loss. Catching poor
          repayment capacity before disbursement is cheaper than recovering from it after.
        </p>
      </div>
    </section>
  );
};
